import { Box, Container, Link, SpaceBetween } from '@cloudscape-design/components';
import { ReviewText } from './ReviewText';
import { StarsIcon } from './StarsIcon';

export type ReviewContentProps = {
  review_id?: string;
  text?: string | null;
  stars?: number;
  highlights?: string[];
  recency?: string;
  highlightCaseSensitive?: boolean;
  truncateCharacters?: number;
};

export function ReviewContent(props: ReviewContentProps) {
  const {
    review_id,
    text,
    stars,
    highlights,
    recency,
    highlightCaseSensitive,
    truncateCharacters,
  } = props;

  return (
    <SpaceBetween direction="vertical" size="xxxs">
      <SpaceBetween direction="horizontal" size="m">
        {stars !== undefined ? (
          <SpaceBetween direction="horizontal" size="m">
            <StarsIcon stars={stars} />
            {' | '}
            <Box variant="span">{recency}</Box>
          </SpaceBetween>
        ) : (
          <Box variant="span">{recency}</Box>
        )}
        {/* <Link variant="secondary" href={`https://maps.app.goo.gl/${review_id}`}>View</Link> */}
      </SpaceBetween>
      <ReviewText
        text={text}
        highlights={highlights}
        highlightCaseSensitive={highlightCaseSensitive}
        maxCharacters={truncateCharacters}
      />
    </SpaceBetween>
  );
}
